import React, { useState } from 'react';
import classnames from 'classnames';

const FilterLayout = ({ textHeader, children, open = true }) => {

    const [opened, setOpened] = useState(open)
    const handlePress = (e) => {
        if(e.key = "Enter"){
            setOpened(oldState => !oldState)
        }
    }
    return (
        <section className={classnames('uk-card-body', { 'uk-open': opened }, 'aps-filter-layout')}>
            <h3 className="uk-accordion-title uk-margin-remove aps-filter-layout-heading" tabIndex={0} onKeyPress={handlePress}>{textHeader}</h3>
            <div className="uk-accordion-content" aria-hidden={!opened} hidden={!opened}>
                {children}
            </div>
        </section>
    );
};

export default FilterLayout;
